import { Pipe, PipeTransform } from '@angular/core';
import { LegalDateTimeService } from '../services/legal-datetime.service';

@Pipe({
  name: 'auditDateCompare'
})
export class AuditDateComparePipe implements PipeTransform {
  constructor(private legalDate: LegalDateTimeService) {}

  transform(
    left: string | number | Date | null | undefined,
    operator: string,
    right: string | number | Date | null | undefined
  ): boolean {
    return this.legalDate.matchesAudit(left, operator, right);
  }
}
